<template>
  <div>
    <CModal
      :show.sync="$store.state.showModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Modal title 2"
      size="lg"
      color="dark"
    >
      <CRow v-if="form">
        <CCol col="12">
          <CCard>
            <CCardBody>
              <CForm>
                <CRow class="mt-3">
                  <CCol sm="12" md="9">
                    <CInput
                      invalid
                      description=""
                      label="الاسم"
                      horizontal
                      autocomplete="name"
                      v-model.trim="form.name"
                      invalid-feedback="يوجد خطأ في هذا الحقل"
                      :is-valid="!$v.form.name.$anyError"
                    />
                  </CCol>
                </CRow>

                <CRow class="mt-3">
                  <CCol sm="12" md="9">
                    <CInput
                      invalid
                      description=""
                      label="اسم المستخدم"
                      horizontal
                      autocomplete="username"
                      v-model.trim="form.username"
                      invalid-feedback="يوجد خطأ في هذا الحقل"
                      :is-valid="!$v.form.username.$anyError"
                    />
                  </CCol>
                </CRow>

                <CRow class="mt-3">
                  <CCol sm="12" md="9">
                    <CInput
                      type="password"
                      invalid
                      description=""
                      label="كلمة المرور"
                      horizontal
                      autocomplete="password"
                      v-model.trim="form.password"
                      invalid-feedback="يوجد خطأ في هذا الحقل"
                      :is-valid="!$v.form.password.$anyError"
                    />
                  </CCol>
                </CRow>

                <CRow class="mt-3">
                  <CCol sm="12" md="9">
                    <CInput
                      description=""
                      label="رقم الموبايل"
                      horizontal
                      autocomplete="phone"
                      v-model.trim="form.mobile"
                      invalid-feedback="يوجد خطأ في هذا الحقل"
                      :is-valid="!$v.form.mobile.$anyError"
                    />
                  </CCol>
                </CRow>

                <CRow class="mt-3">
                  <CCol sm="12" md="9">
                    <div role="group" class="form-group form-row">
                      <label class="col-form-label col-sm-3">
                        حالة الاداري
                      </label>
                      <CCol sm="9">
                        <div role="group" class="form-check form-check-inline">
                          <label>
                            <input
                              type="radio"
                              name="category_id"
                              class="form-check-input"
                              value="1"
                              v-model="form.is_active"
                            />
                            نشط
                          </label>
                        </div>

                        <div role="group" class="form-check form-check-inline">
                          <label>
                            <input
                              type="radio"
                              name="category_id"
                              class="form-check-input"
                              value="0"
                              v-model="form.is_active"
                            />
                            متوقف
                          </label>
                        </div>
                      </CCol>
                    </div>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
            <CCardFooter v-if="formErrors">
              <CAlert color="danger">
                <CListGroup flush>
                  <CListGroupItem
                    v-for="(err, index) in formErrors"
                    :key="index"
                  >
                    {{ err[0] }}
                  </CListGroupItem>
                </CListGroup>
              </CAlert>
            </CCardFooter>
          </CCard>
        </CCol>
      </CRow>
      <template v-if="form" #header>
        <h6 class="modal-title font-weight-bold">
          تعديل الاداري رقم : {{ form.id }}
        </h6>
        <CButtonClose @click="closeModal" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="closeModal" color="danger">الغاء</CButton>

        <CButton
          :disabled="loading"
          @click="update"
          type="button"
          color="success"
        >
          <CSpinner v-if="loading" color="white" size="sm" />
          <span v-else> <CIcon name="cil-save" /> حفظ </span>
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
export default {
  name: "Edit",
  props: ["form"],
  data() {
    return {
      loading: false,
      formErrors: null,
    };
  },
  validations: {
    form: {
      name: { required, min: minLength(2) },
      username: { required, min: minLength(3) },
      password: { min: minLength(6) },
      mobile: { required, min: minLength(10) },
    },
  },
  created() {},
  methods: {
    closeModal() {
      this.$store.commit("set", ["showModal", false]);
    },
    update() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return true;
      }
      this.loading = true;
      const data = (({ name, username, password, mobile, is_active }) => ({
        name,
        username,
        password,
        mobile,
        is_active,
      }))(this.form);

      this.$http
        .put(`/admins/${this.form.id}`, data)
        .then((res) => {
          // handle success
          if (res.data.status == 200) {
            this.$emit("updateDone");
            this.$store.commit("set", ["showModal", false]);
          }
          this.loading = false;
        })
        .catch((error) => {
          // handle error
          this.loading = false;
          if ((error.response.data.status == 422)) {
            this.formErrors = error.response.data.error.errors;
          }
        });
    },
  },
};
</script>
